import theme from '@ifca-root/react-component/src/assets/theme'
import CardExpansion from '@ifca-root/react-component/src/components/CardList/CardExpansion'
import EmptyList from '@ifca-root/react-component/src/components/CardList/EmptyList'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import IconText from '@ifca-root/react-component/src/components/Typography/IconText'
import {
  Checkbox,
  CircularProgress,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Tooltip,
  useMediaQuery,
  withStyles,
} from '@material-ui/core'
import ListAltIcon from '@material-ui/icons/ListAlt'
import SubmitterLog from 'assets/icons/GeneralLedger/submitter-log.svg'
import { CardExpansionHeader } from 'components/CardExpansion/CardExpansionHeader'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import { RejectDialog } from 'components/Dialog/RejectDialog'
import { SubmitterDialog } from 'components/Dialog/SubmitterDialog'
import { advancedFilterList } from 'components/Filter/AdvancedFilter'
import { AccountFooter } from 'components/Footer/AccountFooter'
import SnackBarContext from 'containers/App/Store/SnackBarContext'
import {
  AcctPermission,
  ApprovalStatus,
  useActionOnAssetStatusMutation,
} from 'generated/graphql'
import { useColorStatusList } from 'helpers/Hooks/useColorStatusList'
import { useMenuOption } from 'helpers/Hooks/useMenuOption'
import { usePermissionChecker } from 'helpers/Hooks/usePermissionChecker'
import { formatDate, formatTime } from 'helpers/StringNumberFunction/FormatDate'
import { amtStr } from 'helpers/StringNumberFunction/NumFormatters'
import React, { Fragment, useContext, useEffect, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useParams } from 'react-router'
import { AssetsRegistrationDepreciationDetailContent } from '../AssetsRegistrationDetail/AssetsRegistrationDepreciationDetailContent'
import { AssetsRegistrationDetailContent } from '../AssetsRegistrationDetail/AssetsRegistrationDetailContent'
import { AssetsRegistrationUsedDepartmentDetailContent } from '../AssetsRegistrationDetail/AssetsRegistrationUsedDepartmentDetailContent'

export const AssetRegistrationPostingList = (props: any) => {
  const {
    filteredList,
    listLoading,
    listStatus,
    postIDs,
    setPostIDs,
    userList,
    setOriginalListing,
    fetchMore,
    selectedField,
    sortOrder,
    TotalLength,
  } = props

  const getSearch = JSON.parse(localStorage.getItem('searchFilter'))
  const { CompanyID }: any = useParams()
  const { menu: menu2, handleClick: handleClick2 }: any = useMenuOption()
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  })
  const { handleStatusColor, handleStatusRename } = useColorStatusList()

  /* -------------------------------------------- */
  /*                     STATE                    */
  /* -------------------------------------------- */
  const [openDialog, setOpenDialog] = useState(false)
  const [openRejectDialog, setOpenRejectDialog] = useState(false)
  const [clickReject, setIsReject] = useState(false)
  const [rejectDialogInput, setRejectDialogInput] = useState({
    RejectionRemark: '',
    RejectionDate: new Date(),
  })
  const { setOpenSnackBar, setSnackBarMsg }: any = useContext(
    SnackBarContext as any
  )
  const [errMessage, setErrMessage] = useState(null)
  const [errDialog, setErrDialog] = useState(false)
  const [postDialog, setPostDialog] = useState(false)

  /* -------------------------------------------- */
  /*                     QUERY                    */
  /* -------------------------------------------- */
  const [
    actionOnAssetStatus,
    { loading: actionOnAssetStatusLoading },
  ] = useActionOnAssetStatusMutation({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: data => {
      setOpenSnackBar(true)
      setSnackBarMsg(
        clickReject
          ? 'Asset(s) rejected successfully'
          : 'Asset(s) approved successfully'
      )
      setPostIDs(new Set([]))
      setOriginalListing([])
      setIsReject(false)
      setOpenRejectDialog(false)
      setRejectDialogInput({
        RejectionRemark: '',
        RejectionDate: new Date(),
      })

      // Refresh the list
      fetchMore({
        variables: {
          CompanyID: CompanyID,
          StatusArr: [listStatus],
          take: 30,
          skip: 0,
          searchValue:
            getSearch?.name === '' || getSearch?.name === undefined
              ? undefined
              : getSearch?.name,
          sortField: selectedField === null ? undefined : selectedField,
          sortOrder: sortOrder === null ? undefined : sortOrder,
        },
      })
    },
  })

  /* -------------------------------------------- */
  /*                   FUNCTION                   */
  /* -------------------------------------------- */
  const formatDateToString = (date: Date): string => {
    const d = new Date(date)
    const year = d.getFullYear()
    const month = String(d.getMonth() + 1).padStart(2, '0')
    const day = String(d.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  }

  const handleSelectAll = e => {
    let jTemp = postIDs
    if (e.target.checked) {
      filteredList.map(v => {
        jTemp.add(v?.fa_asset_id)
      })
    } else {
      jTemp.clear()
    }
    setPostIDs(new Set(jTemp))
  }

  const handleCheckBoxChange = (e: any, postID, index: number) => {
    let temp = postIDs
    if (!temp.has(postID)) {
      temp.add(postID)
    } else {
      temp.delete(postID)
    }
    setPostIDs(new Set(temp))
  }

  let listPostIDs: any = Array.from(postIDs || [])

  let checkedData = []
  listPostIDs.map(ID => {
    filteredList.map(el => {
      if (el?.fa_asset_id === ID) {
        checkedData.push(el)
      }
    })
  })

  const { handlePermDisabled } = usePermissionChecker()

  /* -------------------------------------------- */
  /*                    SUBMIT                    */
  /* -------------------------------------------- */
  const onSubmitApprove = () => {
    if (postIDs.size === 0) {
      setErrMessage('Please select at least one asset to approve')
      setErrDialog(true)
      return
    }

    setIsReject(false)
    actionOnAssetStatus({
      variables: {
        CompanyID: CompanyID,
        fa_asset_id: Array.from(postIDs),
        ApprovalStatus: ApprovalStatus.Completed,
        input: null,
      },
    })
  }

  const onSubmitReject = () => {
    if (postIDs.size === 0) {
      setErrMessage('Please select at least one asset to reject')
      setErrDialog(true)
      return
    }

    if (
      !rejectDialogInput.RejectionRemark ||
      rejectDialogInput.RejectionRemark.trim() === ''
    ) {
      setErrMessage('Rejection remark is required')
      setErrDialog(true)
      return
    }

    setIsReject(true)
    const rejectionDateStr = formatDateToString(
      rejectDialogInput.RejectionDate || new Date()
    )

    actionOnAssetStatus({
      variables: {
        CompanyID: CompanyID,
        fa_asset_id: Array.from(postIDs),
        ApprovalStatus: ApprovalStatus.Rejected,
        input: {
          RejectionRemark: rejectDialogInput.RejectionRemark,
          RejectionDate: rejectionDateStr,
        },
      },
    })
  }

  useEffect(() => {
    if (clickReject && rejectDialogInput.RejectionRemark) {
      onSubmitReject()
    }
  }, [clickReject])

  return (
    <>
      {(listLoading || actionOnAssetStatusLoading) && <Loading />}
      <ContentWrapper style={{ marginTop: isDesktop ? '70px' : '-7px' }}>
        {listStatus === 'SUBMIT' && filteredList?.length !== 0 ? (
          <span className="mdDesc flex-space" style={{ paddingLeft: '7px' }}>
            <Checkbox
              onChange={handleSelectAll}
              color="primary"
              value={''}
              checked={
                postIDs?.size === filteredList?.length &&
                filteredList?.length > 0
              }
              style={{ marginLeft: '-5px', marginTop: '-5px' }}
              disabled={
                actionOnAssetStatusLoading ||
                handlePermDisabled({
                  companyID: CompanyID,
                  permEnum:
                    AcctPermission.FixedAssetsAssetsRegistrationApproveReject,
                })
              }
            />
            <span style={{ marginLeft: '9px' }}>Select All</span>
          </span>
        ) : null}

        <List className="core-list">
          {filteredList === undefined || filteredList?.length === 0 ? (
            <EmptyList
              title="No Record found"
              subtitle="Add a new record now."
            />
          ) : (
            <InfiniteScroll
              dataLength={filteredList?.length}
              next={() => {
                const currentLength = filteredList?.length
                fetchMore({
                  variables: {
                    CompanyID: CompanyID,
                    StatusArr:
                      listStatus === 'COMPLETED'
                        ? [listStatus, ApprovalStatus.Cancelled]
                        : [listStatus],
                    take: 30,
                    skip: currentLength,
                    searchValue:
                      getSearch?.name === '' || getSearch?.name === undefined
                        ? undefined
                        : getSearch?.name,
                    sortField:
                      selectedField === null ? undefined : selectedField,
                    sortOrder: sortOrder === null ? undefined : sortOrder,
                  },
                })
              }}
              hasMore={filteredList?.length < TotalLength}
              className=""
              style={{ padding: '8px 6px' }}
              loader={
                listLoading && (
                  <div style={{ textAlign: 'center' }}>
                    <CircularProgress />
                  </div>
                )
              }
              endMessage={
                <p style={{ textAlign: 'center' }}>
                  <b>-</b>
                </p>
              }
            >
              {advancedFilterList(filteredList)?.map((el, index) => {
                return (
                  <CardExpansion
                    key={el?.fa_asset_id || index}
                    summary={
                      <ListItem>
                        {listStatus === 'SUBMIT' ? (
                          <FormControl
                            component="fieldset"
                            style={{ width: '16px' }}
                          >
                            <FormControlLabel
                              control={
                                <Checkbox
                                  value={el.fa_asset_id}
                                  onChange={e => {
                                    handleCheckBoxChange(
                                      e,
                                      el?.fa_asset_id,
                                      index
                                    )
                                  }}
                                  onClick={e => e.stopPropagation()}
                                  checked={postIDs?.has(el?.fa_asset_id)}
                                  color="primary"
                                  style={{
                                    marginLeft: '10px',
                                    marginRight: '-5px',
                                  }}
                                  disabled={
                                    actionOnAssetStatusLoading ||
                                    handlePermDisabled({
                                      companyID: CompanyID,
                                      permEnum:
                                        AcctPermission.FixedAssetsAssetsRegistrationApproveReject,
                                    })
                                  }
                                />
                              }
                              label=""
                              name="check"
                            />
                          </FormControl>
                        ) : null}

                        <ListItemText
                          style={{
                            marginLeft: listStatus === 'SUBMIT' ? '25px' : null,
                          }}
                          primary={
                            <>
                              <span className="desc date-width">
                                {formatDate(el?.registration_date)}
                              </span>
                              <span className="xsTitle flex-space click-text">
                                {el?.DocNo}
                              </span>
                              <span className="xxTitle highlight-text">
                                {amtStr(el?.original_net_amount)}
                              </span>
                            </>
                          }
                          secondary={
                            <Grid
                              container
                              className="desc flex-space text-noflow"
                            >
                              <Grid
                                spacing={1}
                                container
                                className="table-content"
                                style={{
                                  paddingTop: '5px',
                                }}
                              >
                                <Grid item xs={12}>
                                  <span
                                    className="desc flex-space"
                                    style={{ marginBottom: '-5px' }}
                                  >
                                    {el?.asset_card_no}
                                  </span>
                                </Grid>
                              </Grid>
                              <Grid
                                spacing={1}
                                container
                                className="table-content"
                                style={{
                                  paddingTop: '5px',
                                }}
                              >
                                <Grid item xs={12}>
                                  <span
                                    className="desc flex-space"
                                    style={{ marginBottom: '-5px' }}
                                  >
                                    {el?.name}
                                  </span>
                                </Grid>
                              </Grid>
                              <Grid
                                spacing={1}
                                container
                                className="table-content"
                                style={{
                                  paddingTop: '5px',
                                }}
                              >
                                <Grid
                                  item
                                  xs={8}
                                  style={{
                                    marginTop: '5px',
                                  }}
                                >
                                  <div className="icon-text">
                                    <Tooltip
                                      disableFocusListener
                                      title={
                                        <Fragment>
                                          <Grid
                                            container
                                            wrap="nowrap"
                                            spacing={2}
                                          >
                                            <Grid item>
                                              <IconText
                                                icon={
                                                  <img
                                                    src={SubmitterLog}
                                                    style={{
                                                      width: '12px',
                                                      marginRight: '3px',
                                                    }}
                                                  />
                                                }
                                                font="desc"
                                              />
                                            </Grid>
                                            <Grid item xs zeroMinWidth>
                                              <div style={{ fontSize: '12px' }}>
                                                {
                                                  userList?.find(
                                                    x =>
                                                      x?.ID ===
                                                        el?.submittedBy ??
                                                      el?.modBy ??
                                                      el?.createdBy
                                                  )?.name
                                                }
                                              </div>
                                              <div style={{ fontSize: '10px' }}>
                                                {formatDate(
                                                  el?.modTs ?? el?.submittedTs
                                                )}
                                                &nbsp;
                                                {formatTime(
                                                  el?.modTs ?? el?.submittedTs
                                                )}
                                              </div>
                                            </Grid>
                                          </Grid>
                                        </Fragment>
                                      }
                                      arrow
                                      enterTouchDelay={0}
                                    >
                                      <div>
                                        <IconText
                                          icon={
                                            <img
                                              src={SubmitterLog}
                                              style={{
                                                width: '12px',
                                                marginRight: '3px',
                                              }}
                                            />
                                          }
                                          font="desc"
                                        />
                                      </div>
                                    </Tooltip>
                                    <span
                                      className="desc"
                                      style={{
                                        marginBottom: '3px',
                                        wordBreak: 'break-word',
                                        whiteSpace: 'normal',
                                        display: 'inline-block',
                                        width: 'calc(100% - 20px)',
                                      }}
                                    >
                                      {el?.remark}
                                    </span>
                                  </div>
                                </Grid>
                                <Grid
                                  item
                                  xs={4}
                                  container
                                  justifyContent="flex-end"
                                  alignItems="center"
                                >
                                  <span className="desc">
                                    <IconButton
                                      style={{
                                        padding: '0px',
                                        paddingRight: '5px',
                                      }}
                                      className="desc"
                                    >
                                      <ListAltIcon
                                        style={{ fontSize: '13px' }}
                                      />
                                    </IconButton>
                                  </span>
                                  <span
                                    className="desc"
                                    style={{
                                      color: `${handleStatusColor(
                                        el?.ApprovalStatus
                                      )}`,
                                    }}
                                  >
                                    {handleStatusRename(el?.ApprovalStatus)}
                                  </span>
                                </Grid>
                              </Grid>
                            </Grid>
                          }
                        />
                      </ListItem>
                    }
                  >
                    {/* Asset Registration Detail */}
                    <AssetsRegistrationDetailContent
                      listEl={el}
                      documentListing={el?.Attachment}
                      listStatus={listStatus}
                      userList={userList}
                      mode={'expansion'}
                    />

                    {/* Depreciation Section */}
                    <CardExpansionHeader title={'Depreciation'} />
                    <AssetsRegistrationDepreciationDetailContent
                      listDepreciation={{
                        Method: el?.DepreciationMethod?.name || '-',
                        StartYear: el?.depreciation_start_year || '-',
                        StartPeriod: el?.depreciation_start_period || '-',
                        AccDepreciationAmount:
                          el?.opening_accumulated_depreciation || 0,
                        UsefulLife: el?.opening_depreciation_useful_life || 0,
                        UtilizedUsefulLife:
                          el?.depreciation_utilized_useful_life || 0,
                        AccRevaluationAmount:
                          el?.depreciation_revaluation_amount || 0,
                        AccProvisionImpairment:
                          el?.depreciation_provision_impairment || 0,
                        AccReversalImpairment:
                          el?.depreciation_reversal_impairment || 0,
                      }}
                    />

                    {/* Used Department Section */}
                    {el?.UsedDepartment && el?.UsedDepartment?.length > 0 && (
                      <>
                        <CardExpansionHeader title={'Used Department'} />
                        <AssetsRegistrationUsedDepartmentDetailContent
                          listUsedDepartment={el?.UsedDepartment}
                        />
                      </>
                    )}
                  </CardExpansion>
                )
              })}
            </InfiniteScroll>
          )}
        </List>
        <div style={{ marginBottom: '100px' }}></div>
      </ContentWrapper>

      <SubmitterDialog
        data={menu2?.obj}
        setOpenDialog={setOpenDialog}
        openDialog={openDialog}
        moduleName={'Asset Registration'}
      />

      <RejectDialog
        data={checkedData}
        openRejectDialog={openRejectDialog}
        setOpenRejectDialog={setOpenRejectDialog}
        setRejectDialogInput={setRejectDialogInput}
        setIsReject={setIsReject}
      />

      {listStatus === 'SUBMIT' ? (
        <AccountFooter
          options={[
            {
              name: 'Reject',
              onClick: () => {
                if (postIDs.size === 0) {
                  setErrMessage('Please select at least one asset to reject')
                  setErrDialog(true)
                  return
                }
                setOpenRejectDialog(true)
              },
              color: 'secondary',
              props: {
                disabled:
                  postIDs.size === 0 ||
                  actionOnAssetStatusLoading ||
                  handlePermDisabled({
                    companyID: CompanyID,
                    permEnum:
                      AcctPermission.FixedAssetsAssetsRegistrationApproveReject,
                  }),
              },
            },
            {
              name: 'Approve',
              onClick: () => {
                onSubmitApprove()
              },
              color: 'primary',
              props: {
                disabled:
                  postIDs.size === 0 ||
                  actionOnAssetStatusLoading ||
                  handlePermDisabled({
                    companyID: CompanyID,
                    permEnum:
                      AcctPermission.FixedAssetsAssetsRegistrationApproveReject,
                  }),
              },
            },
          ]}
        />
      ) : null}

      <ErrorDialog
        errorDia={errDialog}
        setErrorDia={setErrDialog}
        errorMsg={errMessage}
        errorHeaderMsg={'Error!'}
      />

      <ErrorDialog
        errorDia={postDialog}
        setErrorDia={setPostDialog}
        errorMsg={errMessage}
        errorHeaderMsg={'Error!'}
        isBool
        onclick={() => {
          setPostDialog(false)
          window.location.reload()
        }}
      />
    </>
  )
}
